import label from "@/lang/StaticLabels.js";

// PAFTERSALES Navbar  - خدمات پس از فروش -----------------------------------------------
let navItems = [
  {
    title: label.modules.pafterSales,
    icon: "mdi-tools",
    to: false,
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: "PAFTERSALESServiceSupportList",
        label: label.menu.serviceSupports,
        metaLabel: label.page.serviceSupports,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
